export default "__VITE_PUBLIC_ASSET__af334ede__"